import { faq } from '../services/ApiService';
import { faqConstants } from '../constants/faq';

export const setTreeList = (tree = []) => ({
  type: faqConstants.SET_FAQ_TREE_LIST_SUCCESS,
  tree,
});

export const startSetTreeList = () => dispatch => {
  return faq
    .getTree()
    .then((data = {}) => dispatch(setTreeList(data.items)))
    .catch(err => dispatch({ type: faqConstants.SET_FAQ_TREE_LIST_FAILURE }));
};

export const setLastUpdateList = (lastUpdate = []) => ({
  type: faqConstants.SET_FAQ_LAST_UPDATE_SUCCESS,
  lastUpdate,
});

export const startSetLastUpdateList = () => dispatch => {
  return faq
    .getLastUpdate()
    .then((data = {}) => dispatch(setLastUpdateList(data.items)))
    .catch(err => dispatch({ type: faqConstants.SET_FAQ_LAST_UPDATE_FAILURE }));
};

export const setFaqPage = page => ({
  type: faqConstants.SET_FAQ_PAGE_SUCCESS,
  page,
});

export const startSetFaqPage = faqId => dispatch => {
  return faq
    .getFaq(faqId)
    .catch(function(err) {
      if (err.response.data && err.response.data.response && err.response.data.response.redirect) {
        return faq.getFaq(err.response.data.response.redirect);
      }

      return faq.getFaq(faqConstants.DEFAULT_PAGE);
    })
    .then((data = { items: [] }) => {
      if (!data.items[0]) {
        return faq
          .getFaq(faqConstants.DEFAULT_PAGE)
          .then((data = { items: [] }) => dispatch(setFaqPage(data.items[0])));
      }
      return dispatch(setFaqPage(data.items[0]));
    })
    .catch(err => dispatch({ type: faqConstants.SET_FAQ_PAGE_FAILURE }));
};

export const setFaqPageRecommendation = recommendation => ({
  type: faqConstants.SET_FAQ_RECOMMENDATION_SUCCESS,
  recommendation,
});

export const startSetFaqRecommendation = faqId => dispatch => {
  return faq
    .getFaq(faqId)
    .catch(function(err) {
      if (err.response.data && err.response.data.response && err.response.data.response.redirect) {
        return faq.getFaq(err.response.data.response.redirect);
      }

      return faq.getFaq(faqConstants.DEFAULT_PAGE);
    })
    .then((data = { items: [] }) => {
      if (!data.items[0]) {
        return faq
          .getFaq(faqConstants.DEFAULT_PAGE)
          .then(data => dispatch(setFaqPageRecommendation(data.items[0])));
      }
      return dispatch(setFaqPageRecommendation(data.items[0]));
    })
    .catch(err => dispatch({ type: faqConstants.SET_FAQ_RECOMMENDATION_FAILURE }));
};

export const setFaqList = (list = []) => ({
  type: faqConstants.SET_FAQ_LIST_SUCCESS,
  list,
});

export const startSetFaqList = () => dispatch => {
  return faq
    .getList()
    .then((data = {}) => dispatch(setFaqList(data.items)))
    .catch(err => dispatch({ type: faqConstants.SET_FAQ_LIST_FAILURE }));
};

export const setFaqGlossaryList = (glossary = {}) => ({
  type: faqConstants.SET_FAQ_GLOSSARY_SUCCESS,
  glossary,
});

export const startSetFaqGlossary = () => dispatch => {
  return faq
    .getGlossary()
    .then((data = {}) => dispatch(setFaqGlossaryList(data.items)))
    .catch(err => dispatch({ type: faqConstants.SET_FAQ_GLOSSARY_FAILURE }));
};

export const setFaqSearchList = (list = []) => ({
  type: faqConstants.SET_FAQ_SEARCH_SUCCESS,
  searchList: list,
});

export const startSetFaqSearch = params => dispatch => {
  return faq
    .search(params)
    .then((data = {}) => dispatch(setFaqSearchList(data.items)))
    .catch(err => dispatch({ type: faqConstants.SET_FAQ_SEARCH_FAILURE }));
};

export const startSetFaqVote = (faqId, params) => dispatch => {
  return faq
    .setVote(faqId, params)
    .then(() => dispatch({ type: faqConstants.SET_FAQ_VOTE_SUCCESS }))
    .catch(() => dispatch({ type: faqConstants.SET_FAQ_VOTE_FAILURE }));
};
